export const site = {
  name: "Hossain Abedy",
  role: "Cybersecurity & Infrastructure Engineer",
  subtitle:
    "Based in Dhaka, Bangladesh, I build, secure, and automate enterprise systems across security operations, applications, infrastructure, and full-stack development. My work combines banking-scale environments, endpoint and network security, and practical engineering with automation and threat analysis.",
  email: "abedy.ltu@gmail.com",
  linkedin: "https://linkedin.com/in/hossainabedy",
  github: "https://github.com/HossainAbedy",
  cta: "Open to cybersecurity engineering, SOC operations, AppSec, network security, and automation roles.",
};